import { render, staticRenderFns } from "./FaqAdmin.vue?vue&type=template&id=3fb4c64f&lang=pug&"
import script from "./FaqAdmin.vue?vue&type=script&lang=js&"
export * from "./FaqAdmin.vue?vue&type=script&lang=js&"
import style0 from "./FaqAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports